export default __webpack_public_path__ + "static/media/LondrinaSolid-Black.f843e880.ttf";